module.exports = __webpack_public_path__ + "static/img/donation.f3932ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default/donation.png
// module id = +y+v
// module chunks = 1